import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBalanceReportComponent } from './customer-balance-report.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    CustomerBalanceReportComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    FormsModule,
    RouterModule
  ],
  exports: [CustomerBalanceReportComponent]
})
export class CustomerBalanceReportModule { }
